module.exports = __webpack_public_path__ + "img/5-l.51cf7287.png";